import * as React from "react"

const SvgSupport = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.286a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9q0-2.076.788-3.9A10.1 10.1 0 0 1 4.925 5.21Q6.275 3.86 8.1 3.072a9.7 9.7 0 0 1 3.9-.787 9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137a9.7 9.7 0 0 1-3.9.788Zm-2.9-2.55 1.2-2.75a4.7 4.7 0 0 1-1.813-1.163A5.7 5.7 0 0 1 7.3 13.986l-2.75 1.15a7.5 7.5 0 0 0 1.775 2.8q1.2 1.2 2.775 1.8m-1.8-9.15q.425-1.05 1.188-1.838A4.7 4.7 0 0 1 10.3 7.586l-1.15-2.75q-1.6.6-2.8 1.8t-1.8 2.8zm4.7 4.7q1.25 0 2.125-.875A2.9 2.9 0 0 0 15 12.286q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 9.286a2.9 2.9 0 0 0-2.125.875A2.9 2.9 0 0 0 9 12.286q0 1.25.875 2.125a2.9 2.9 0 0 0 2.125.875m2.9 4.45a7.8 7.8 0 0 0 2.763-1.788 7.8 7.8 0 0 0 1.787-2.762l-2.75-1.2q-.375 1.05-1.15 1.812a5.6 5.6 0 0 1-1.8 1.188zm1.8-9.2 2.75-1.15a7.8 7.8 0 0 0-1.787-2.763A7.8 7.8 0 0 0 14.9 4.836l-1.15 2.8q1.025.375 1.775 1.137c.75.762.892 1.096 1.175 1.763" />
  </svg>
)
export default SvgSupport
